/**
 * @name appApiUrl
 * @description
 * This is config file, it include the api urls of the application
 * Define Settings the object way(based on requirement):
 * @example
 * {paramsName}:{value}
 * @constant appApiUrl
 * @type {CommonBase}
 */
export const appApiUrl = Object.freeze({
  auth: {
    login: 'auth/login',
    checkEmail: 'auth/check-email',
    signup: 'auth/signup',
  },
  users: {
    role: 'users/role'
  },
  stripe: {
    renewSubscription: 'stripe/renew-subscription',
    autoRenew: 'stripe/auto-renew',
    customerCard: 'stripe/customer-card',
    lastPayment: 'stripe/last-payment',
    updateCard: 'stripe/update-card'
  },
  attribute: 'attribute'
});
